
import { defineComponent, ref, reactive } from "vue";
import MyTable from "@/components/MyTable/index.vue";
import { Search } from "@element-plus/icons-vue";
import { Reslist, modifyState, reseditRes, resAddresone, menulist, menumodifyState, Addmenu, Edmenu, resupdate } from "@/api/Menuconfiguration";
import { ElMessage } from "element-plus";
import type { FormInstance, FormRules } from "element-plus";
import { useRouter } from "vue-router";
export default defineComponent({
  components: {
    MyTable,
  },
  setup() {
    const router = useRouter();
    const typelist = ref<{ type: number | string; name: string }[]>([
      { type: 0, name: "商户主后台菜单" },
      { type: 1, name: "商户门店后台菜单" },
    ]);
    const tableData = ref<any>();
    const Title = ref("");
    const tableColumn = ref([
      {
        prop: "resourceName",
        label: "菜单名称",
      },
      {
        slotName: "accounttype",
      },
      {
        slotName: "Sort",
      },

      {
        slotName: "slotName",
      },
    ]);
    const ruleFormRef = ref<FormInstance>();
    const modelrules = reactive<FormRules>({
      resourceName: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
    });
    const ruleFormRef2 = ref<FormInstance>();
    const modelrules2 = reactive<FormRules>({
      menuName: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
    });
    const SearchClass = () => {
      getzhtTable();
    };
    const zhtText = ref<any>();
    const zhtData = ref<any>({
      resourceName: "",
      pageSize: 1,
      pageNum: 10,
    });
    const imageUrl = ref();
    const imageUrl2 = ref();
    const getzhtTable = () => {
      Reslist(zhtData.value).then((res) => {
        console.log(res);
        tableData.value = res.data;
      });
    };
    getzhtTable();
    const GooldData = ref<any>({
      command: "",
      merchantId: 0,
      resourceNo: 0,
    });
    // 主后台推送开关
    const pushDisplay = ref<boolean>(false);
    const switchFn = (row: any) => {
      console.log(row);
      GooldData.value.merchantId = row.merchantId;
      GooldData.value.resourceNo = row.resourceNo;
      zhtText.value = "启用推送后，商户端将自动接收该分类数据，操作不可逆，确认要继续吗";
      gooleshow.value = true;
      // pushDisplay.value = true;
    };
    const zhtpushDisplay = () => {
      pushDisplay.value = false;
      getzhtTable();
    };
    const zhtClick = () => {
      pushDisplay.value = false;
      gooleshow.value = true;
    };
    // 谷歌
    const gooleshow = ref(false);
    // 谷歌确认
    const onconfirm = (val: any) => {
      console.log(val.ruleForm.gooleId);
      GooldData.value.command = val.ruleForm.gooleId;
      modifyState(GooldData.value).then((res) => {
        if (res.code == 1) {
          ElMessage.success(res.msg as string);
          gooleshow.value = false;
          getzhtTable();
        } else {
          ElMessage.error(res.msg as string);
          gooleshow.value = false;
        }
      });
    };
    const paixudispaly = ref(false);
    const paixudispaly2 = ref(false);
    // 排序
    const formpaixu = ref<any>({
      preResourceNo: "",
      resourceNo: "",
      sort: "",
    });
    const zhtinputnumber = (row: any) => {
      console.log(row);
      paixudispaly.value = true;
      formpaixu.value.preResourceNo = row.preResourceNo;
      formpaixu.value.resourceNo = row.resourceNo;
      formpaixu.value.sort = row.sort;
    };
    const qurenpaixudispaly = () => {
      reseditRes(formpaixu.value).then((res) => {
        console.log(res);
        if (res.code == 1) {
          ElMessage.success(res.msg as string);
          getzhtTable();
        } else {
          ElMessage.error(res.msg as string);
        }
      });
      paixudispaly.value = false;
    };
    const qxpaixudispaly = () => {
      paixudispaly.value = false;
      getzhtTable();
    };
    // 主后台菜单编辑
    const FromData = ref<any>({
      resourceIoc: imageUrl.value,
      resourceName: "",
      resourceNo: 0,
      resourceSys: "00",
      resourceUrl: "",
      sort: 0,
    });
    const EditmenuDisplay = ref<boolean>(false);
    const edit = (row: any) => {
      console.log(row);
      EditmenuDisplay.value = true;
      Title.value = "编辑";
      FromData.value.resourceIoc = row.resourceIoc;
      imageUrl.value = row.resourceIoc;
      FromData.value.resourceName = row.resourceName;
      FromData.value.resourceNo = row.resourceNo;
      FromData.value.resourceSys = row.resourceSys;
      FromData.value.resourceUrl = row.resourceUrl;
      FromData.value.isActive = row.isActive;
      addEd.value = "Ed";
      FromData.value.enableFlag = row.enableFlag;
    };
    // 编辑确认 +  添加一级菜单
    const saveEdit = async (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      await formEl.validate((valid, fields) => {
        if (valid) {
          if (addEd.value == "add") {
            FromData.value.resourceIoc = imageUrl.value;
            resAddresone(FromData.value).then((res) => {
              if (res.code == 1) {
                ElMessage.success(res.msg as string);
                getzhtTable();
                EditmenuDisplay.value = false;
              } else {
                ElMessage.error(res.msg as string);
              }
            });
          } else if (addEd.value == "Ed") {
            FromData.value.resourceIoc = imageUrl.value;
            resupdate(FromData.value).then((res) => {
              if (res.code == 1) {
                ElMessage.success(res.msg as string);
                getzhtTable();
                EditmenuDisplay.value = false;
              } else {
                ElMessage.error(res.msg as string);
              }
            });
          }
        }
      });
    };
    const addEd = ref<any>("");
    // 添加一级菜单
    const addSelectone = () => {
      EditmenuDisplay.value = true;
      Title.value = "添加一级菜单";
      FromData.value.resourceUrl = "";
      FromData.value.resourceName = "";
      delete FromData.value.resourceNo;
      addEd.value = "add";
      FromData2.value.resourceIoc = "";
      imageUrl.value = "";
    };

    //跳转二级
    const goTow = (row: any) => {
      console.log(row);
      router.push({ path: "/Merchantmenu/zht/zhttow", query: { id: row.resourceNo } });
      // router.push("/Merchantmenu/zht/zhttow");
    };
    const tabsTypeValue = ref<any>();
    const tabsType = (type: string | number) => {
      console.log(type);
      if (type == 0) {
        getzhtTable();
      } else {
        getMdTable();
      }
      tabsTypeValue.value = type;
    };
    tabsType(0);

    // 门店222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222
    const tableData2 = ref<any>();
    const tableColumn2 = ref([
      {
        prop: "menuName",
        label: "菜单名称",
      },
      {
        slotName: "enableFlag",
      },
      {
        slotName: "menuSort",
      },

      {
        slotName: "slotName",
      },
    ]);
    const SearchClass2 = () => {
      getMdTable();
    };
    const zhtText2 = ref<any>();
    const zhtData2 = ref<any>({
      pageNum: 1,
      pageSize: 99999,
      merchantId: "",
      menuParentId: "",
      menuName: "",
    });
    const GooldData2 = ref<any>({
      command: "",
      merchantId: 0,
      resourceNo: 0,
    });
    // 门店台推送开关
    const pushDisplay2 = ref<boolean>(false);
    const switchFn2 = (row: any) => {
      console.log(row);
      GooldData2.value.merchantId = 0;
      GooldData2.value.resourceNo = row.id;
      zhtText2.value = "启用推送后，商户端将自动接收该分类数据，操作不可逆，确认要继续吗";

      gooleshow2.value = true;
    };
    const zhtpushDisplay2 = () => {
      pushDisplay2.value = false;
      getMdTable();
    };
    const zhtClick2 = () => {
      pushDisplay2.value = false;
      gooleshow2.value = true;
    };
    // 谷歌
    const gooleshow2 = ref(false);
    // 谷歌确认
    const onconfirm2 = (val: any) => {
      console.log(val.ruleForm.gooleId);
      GooldData2.value.command = val.ruleForm.gooleId;
      menumodifyState(GooldData2.value).then((res) => {
        if (res.code == 1) {
          ElMessage.success(res.msg as string);
          gooleshow2.value = false;
          getMdTable();
        } else {
          ElMessage.error(res.msg as string);
          gooleshow2.value = false;
        }
      });
    };

    // 门店排序

    const formpaixu2 = ref<any>({
      menuName: "",
      menuParentId: "",
      menuSort: "",
      id: "",
      menuType: "",
    });
    const zhtinputnumber2 = (row: any) => {
      console.log(row);
      paixudispaly2.value = true;
      formpaixu2.value.menuName = row.menuName;
      formpaixu2.value.menuParentId = row.menuParentId;
      formpaixu2.value.menuSort = row.menuSort;
      formpaixu2.value.id = row.id;
      formpaixu2.value.menuType = row.menuType;
      formpaixu2.value.menuIcon = row.menuIcon;
    };
    const qurenpaixudispaly2 = () => {
      Edmenu(formpaixu2.value).then((res) => {
        console.log(res);
        if (res.code == 1) {
          ElMessage.success(res.msg as string);
          getMdTable();
        } else {
          ElMessage.error(res.msg as string);
        }
      });
      paixudispaly2.value = false;
    };
    const qxpaixudispaly2 = () => {
      paixudispaly2.value = false;
      getMdTable();
    };
    // 门店菜单编辑
    const FromData2 = ref<any>({
      menuName: "",
      menuParentId: 0,
      menuSort: 100,
      menuType: "DIRECTORY",
      menuUrl: "",
      menuIcon: "",
    });
    const EditmenuDisplay2 = ref<boolean>(false);
    const edit2 = (row: any) => {
      console.log(row);
      EditmenuDisplay2.value = true;
      FromData2.value.menuUrl = row.menuUrl;
      FromData2.value.menuType = row.menuType;
      FromData2.value.menuSort = row.menuSort;
      FromData2.value.menuName = row.menuName;
      imageUrl2.value = row.menuIcon == null ? "" : row.menuIcon;
      FromData2.value.menuIcon = row.menuIcon == null ? "" : row.menuIcon;
      FromData2.value.id = row.id;
      FromData2.value.menuParentId = row.menuParentId;
      FromData2.value.enableFlag = row.enableFlag;
      Title.value = "编辑";
      addEd2.value = "Ed";
    };
    // 编辑确认 +  添加一级菜单
    const saveEdit2 = async (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      await formEl.validate((valid, fields) => {
        if (valid) {
          if (addEd2.value == "add") {
            FromData2.value.menuIcon = imageUrl2.value;
            Addmenu(FromData2.value).then((res) => {
              if (res.code == 1) {
                ElMessage.success(res.msg as string);
                getMdTable();
                EditmenuDisplay2.value = false;
              } else {
                ElMessage.error(res.msg as string);
              }
            });
          } else if (addEd2.value == "Ed") {
            FromData2.value.menuIcon = imageUrl2.value;
            Edmenu(FromData2.value).then((res) => {
              if (res.code == 1) {
                ElMessage.success(res.msg as string);
                getMdTable();
                EditmenuDisplay2.value = false;
              } else {
                ElMessage.error(res.msg as string);
              }
            });
          }
        }
      });
    };

    const addEd2 = ref<any>("");
    // 添加一级菜单
    const addSelectone2 = () => {
      EditmenuDisplay2.value = true;
      Title.value = "添加一级菜单";
      FromData2.value.menuName = "";
      FromData2.value.menuUrl = "";
      FromData2.value.menuIcon = "";
      FromData2.value.menuSort = 0;
      imageUrl2.value = "";
      delete FromData2.value.resourceNo;
      addEd2.value = "add";
    };

    //跳转二级
    const goTow2 = (row: any) => {
      console.log(row);
      router.push({ path: "/Merchantmenu/md/mdtow", query: { id: row.id, name: row.menuName } });
    };
    const getMdTable = () => {
      menulist(zhtData2.value.menuParentId, zhtData2.value.menuName).then((res) => {
        tableData2.value = res.data.list;
      });
    };
    const delectImg = (val: string) => {
      imageUrl.value = val;
    };
    const delectImg2 = (val: string) => {
      imageUrl2.value = val;
    };
    const changeImg = (val: any) => {
      console.log(val, "上传图片");
      imageUrl.value = val.fileUrl;
    };
    const changeImg2 = (val: any) => {
      console.log(val, "上传图片");
      imageUrl2.value = val.fileUrl;
    };
    const onClose = () => {
      // console.log(1);
      getzhtTable();
    };
    const onClose2 = () => {
      getMdTable();
    };
    return {
      typelist,
      tabsType,
      tableColumn2,
      tableData2,
      tableData,
      tableColumn,
      Search,
      onClose2,
      switchFn,
      pushDisplay,
      EditmenuDisplay,
      edit,
      FromData,
      tabsTypeValue,
      zhtData,
      SearchClass,
      zhtpushDisplay,
      zhtClick,
      zhtText,
      gooleshow,
      onconfirm,
      zhtinputnumber,
      saveEdit,
      addSelectone,
      goTow,
      Title,
      FromData2,
      qurenpaixudispaly,
      paixudispaly,
      paixudispaly2,
      qxpaixudispaly,
      qurenpaixudispaly2,
      qxpaixudispaly2,
      // Search2,
      switchFn2,
      pushDisplay2,
      EditmenuDisplay2,
      edit2,
      zhtData2,
      SearchClass2,
      zhtpushDisplay2,
      zhtClick2,
      zhtText2,
      gooleshow2,
      onconfirm2,
      zhtinputnumber2,
      saveEdit2,
      addSelectone2,
      goTow2,
      imageUrl,
      delectImg,
      delectImg2,
      changeImg,
      changeImg2,
      imageUrl2,
      onClose,
      ruleFormRef,
      modelrules,
      ruleFormRef2,
      modelrules2,
    };
  },
});
